export default {
  logo: require('./images/chimichanga_logo.png'),
  spinWheelBase: require('./images/spin_wheel_base.png'),
  spinWheelCenter: require('./images/spin_wheel_center.png'),
  spinWheelCircle: require('./images/spin_wheel_circle.png'),
  spinWheelSelectedCenter: require('./images/spin_wheel_selected_point.png'),
  heroBanner: require('./images/hero_banner.png'),
  heroBanner2021: require('./images/hero_banner.jpg'),
  thankyouHeader2021: require('./images/thankyou_bg_2022_may.png'),
};